export default {
      id: "arrow-48x24-usage",
      viewBox: "0 0 48 24",
      url: __webpack_public_path__ + "assets/iconset.svg#arrow-48x24",
      toString: function () {
        return this.url;
      }
    }